import React from 'react';
import './styles.css';
import { COMMENT_OPEN, COMMENT_CLOSED } from '@BUP/constants';
import { Row, Col, Button, Tag, Tooltip, Popconfirm } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { getMessageCreatorInfo } from '@BUP/services/BraveUp';
import { RBAC } from '@BUP/components';
import { CheckCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import 'moment/locale/es';
import { useTranslation } from 'react-i18next';

const MessageElement = ({ message, handleSetMessageState }) => {
  const history = useHistory();
  const location = useLocation();
  const { messageCreator } = getMessageCreatorInfo(message);
  const isOpenMessage = message?.state === COMMENT_OPEN;
  const [t] = useTranslation();

  return (
    <div className="message-element-container">
      <Row style={{ flex: 1, padding: 15 }}>
        <Col
          xs={24}
          className="content-element"
          style={{ justifyContent: 'space-between' }}
        >
          <div className="info-wrapper">
            <p style={{ margin: 0 }}>{messageCreator}</p>
          </div>
          <RBAC name="messageListStateTag">
            <div className="info-wrapper">
              <Tooltip placement="top" title="Estado del caso.">
                {isOpenMessage ? (
                  <Tag
                    style={{ margin: 0 }}
                    icon={<CheckCircleOutlined />}
                    color="success"
                  >
                    {t('pages.modeBup.inbox.MessageElementComponent.tag1')}
                  </Tag>
                ) : (
                  <Tag
                    style={{ margin: 0 }}
                    icon={<MinusCircleOutlined />}
                    color="default"
                  >
                    {t('pages.modeBup.inbox.MessageElementComponent.tag2')}
                  </Tag>
                )}
              </Tooltip>
            </div>
          </RBAC>
        </Col>
        <Col xs={24} className="content-element message-wrapper">
          <span>{message?.content || ''}</span>
        </Col>
        <Col xs={24} className="content-element date-wrapper">
          {`${moment(message?.createdAt).format('lll')}    
            (${moment(message?.createdAt).fromNow()})`}
          <div>
            <RBAC name="openOrCloseMessageButton">
              <Popconfirm
                placement="topRight"
                title={
                  isOpenMessage
                    ? t(
                        'pages.modeBup.inbox.MessageElementComponent.closeMessage'
                      )
                    : t(
                        'pages.modeBup.inbox.MessageElementComponent.openMessage'
                      )
                }
                onConfirm={async () => {
                  const newState = isOpenMessage
                    ? COMMENT_CLOSED
                    : COMMENT_OPEN;
                  await handleSetMessageState(message.id, newState);
                }}
                okText={t('pages.modeBup.inbox.MessageElementComponent.okText')}
                cancelText={t(
                  'pages.modeBup.inbox.MessageElementComponent.cancelText'
                )}
              >
                <Button type="primary" ghost style={{ fontWeight: 'bold' }}>
                  {isOpenMessage
                    ? t(
                        'pages.modeBup.inbox.MessageElementComponent.isOpenMessageClosed'
                      )
                    : t(
                        'pages.modeBup.inbox.MessageElementComponent.isOpenMessageOpen'
                      )}
                </Button>
              </Popconfirm>
            </RBAC>
            <Button
              type="primary"
              style={{
                fontWeight: 'bold',
                marginLeft: 10,
              }}
              onClick={() => {
                history.push({
                  pathname: `/modebup/direct`,
                  mainMessage: message,
                  messageCreator,
                  prevLocation: location,
                });
              }}
            >
              {isOpenMessage
                ? t(
                    'pages.modeBup.inbox.MessageElementComponent.isOpenMessageOpen2'
                  )
                : t(
                    'pages.modeBup.inbox.MessageElementComponent.isOpenMessageReview'
                  )}
            </Button>
          </div>
        </Col>
        <Col xs={24} className="content-element button-wrapper" />
      </Row>
    </div>
  );
};

export default MessageElement;
